<template>
  <!-- Toggle Button -->
  <label
    :for="context.id"
    :data-type="context.type"
    :class="['my-auto cursor-pointer', context.classes.element]"
  >
    <!-- toggle -->
    <div class="relative">
      <!-- input -->
      <input
        v-model="context.model"
        type="checkbox"
        :value="context.value"
        v-bind="context.attributes"
        class="sr-only absolute border-none cursor-pointer"
        @change="$emit('change', context.value)"
        @blur="context.blurHandler"
      />
      <!-- line -->
      <!-- We use css variables to change the label text because the model can be a single field or an array and it is difficult to bind dynamic content directly -->
      <div
        class="toggle__line"
        :style="{
          '--label-on': `'${$t('on')}'`,
          '--label-off': `'${$t('off')}'`
        }"
      >
        <span
          class="toggle__label tg-tag-small mx-2.5 transition-all duration-300 ease-in-out"
        />
      </div>
      <!-- dot -->
      <div
        class="toggle__dot absolute w-3 h-3 m-1.5 bg-grey-2 my-auto rounded-full inset-y-0"
      />
    </div>
  </label>
</template>

<script>
export default {
  name: 'BaseInputToggle',
  props: {
    context: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
/*
  Design didn't make sense to Julie and Sara either, so we fix the toggle and use the logical positions
  https://dewaele.atlassian.net/browse/DEW-10689
*/

.toggle__dot {
  left: 2px;
  @apply transition-all duration-300 ease-in-out rounded-full;
}
input:checked ~ .toggle__dot {
  @apply bg-green-2;
  transform: translateX(38px);
}

.toggle__line {
  @apply w-16 h-6 flex items-center justify-end border border-grey-2 text-grey-2 rounded-full;
}
input:checked ~ .toggle__line {
  @apply text-green-2 border-green-2 justify-start;
}

.toggle__label::after {
  content: var(--label-off);
}
input:checked ~ .toggle__line .toggle__label::after {
  content: var(--label-on);
}
</style>
